import React from "react";
import C3Chart from "react-c3js";
import { Grid, Card, Table, colors } from "tabler-react";
import moment from "moment";
import useDataFetchWithPusher from "../effects/useDataFetchWithPusher";
const emptyArr = Array(15).fill(0);
const graphMeta = {
  columns: [
    // each columns data
    ["data1", ...emptyArr],
  ],
  type: "area", // default type of chart
  groups: [["data1", "data2", "data3"]],
  colors: {
    data1: colors["blue"],
  },
  names: {
    // name of each serie
    data1: "Purchases",
  },
};
const PurchaseSummary = () => {
  const {
    loading,
    results,
  } = useDataFetchWithPusher("/inventory/recent-purchases", [
    "purchased-item-created",
  ]);

  const {
    loadingGraph,
    results: graphResults,
  } = useDataFetchWithPusher("/inventory/purchases-graph", [
    "purchased-item-created",
  ]);
  let data = graphMeta;
  if (!loadingGraph) {
    data = { ...graphMeta, columns: [["data1", ...graphResults]] };
  }
  return (
    <Grid.Col lg={6}>
      <Card>
        <Card.Header>
          <Card.Title>Purchases</Card.Title>
        </Card.Header>
        <C3Chart
          style={{ height: "10rem" }}
          data={data}
          axis={{
            y: {
              padding: {
                bottom: 0,
              },
              show: false,
              tick: {
                outer: false,
              },
            },
            x: {
              padding: {
                left: 0,
                right: 0,
              },
              show: false,
            },
          }}
          legend={{
            position: "inset",
            padding: 0,
            inset: {
              anchor: "top-left",
              x: 20,
              y: 8,
              step: 10,
            },
          }}
          tooltip={{
            format: {
              title: function (x) {
                return "";
              },
            },
          }}
          padding={{
            bottom: 0,
            left: -1,
            right: -1,
          }}
          point={{
            show: false,
          }}
        />
        <Table
          cards={true}
          striped={true}
          responsive={true}
          className="table-vcenter"
        >
          <Table.Header>
            <Table.Row>
              <Table.ColHeader>Supplier</Table.ColHeader>
              <Table.ColHeader />
              <Table.ColHeader>Item</Table.ColHeader>
              <Table.ColHeader>Date</Table.ColHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {loading && !results.length && (
              <Table.Row>
                <Table.Col>Loading...</Table.Col>
              </Table.Row>
            )}
            {!loading && !results.length && (
              <Table.Row>
                <Table.Col>No results found</Table.Col>
              </Table.Row>
            )}
            {results.map((result) => (
              <Table.Row>
                <Table.Col colSpan={2}>{result.supplierName}</Table.Col>
                <Table.Col>{result.itemName}</Table.Col>
                <Table.Col className="text-nowrap">
                  {moment(result.created).format("MMM Do YYYY")}
                </Table.Col>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Card>
    </Grid.Col>
  );
};

export default PurchaseSummary;
